import React from "react";

import { getProviderAsset, normalizeAffiliateKey } from "./providerAssets";

export const BettoProviderIcon = ({ name, className, alt }) => {
	const src = getProviderAsset(name);

	if (!src) {
		return null;
	}

	const normalized = normalizeAffiliateKey(name);

	return (
		<img
			className={className ?? normalized}
			src={src}
			alt={alt ?? name}
		/>
	);
};
